var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"area-scroll-active"},[_c('div',{staticClass:"m-tree tree-gray"},_vm._l((_vm.treeRoots),function(item){return _c('TreeViewItem',{key:item.id,attrs:{"treeid":_vm.treeViewId,"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }